import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import Avatar from '@/components/avatar/Index.vue';
import PagePreviewWithFormMixin from '@/helpers/vue_mixins/v2/PagePreviewWithFormMixin';
import WebviewBackgroundOverlay from '@/components/v2/preview/WebviewBackgroundOverlay.vue';
import WebviewHeader from '@/components/v2/preview/WebviewHeader.vue';
import { DIY } from '@/helpers/constants/Store';
import { Getter } from 'vuex-class';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import TheClosePreviewTemplate from '@/components/v2/diy/TheClosePreviewTemplate';
let ProductPagePreview = class ProductPagePreview extends mixins(PagePreviewWithFormMixin, ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.webviewHeader = 'Add to Cart';
    }
    get uploadedProductImagePath() {
        const image = this.featuredPhotoUrlFor(this.productDetails.images);
        if (image) {
            return `background-image:url(${image})`;
        }
        return '';
    }
    get mapUndeletedDetails() {
        return this.productDetails.productDetails.filter((element) => {
            return element.state !== 'deleted';
        });
    }
};
__decorate([
    Getter('productDetails', { namespace: DIY })
], ProductPagePreview.prototype, "productDetails", void 0);
ProductPagePreview = __decorate([
    Component({
        components: {
            Avatar,
            WebviewBackgroundOverlay,
            WebviewHeader,
            TheClosePreviewTemplate,
        },
    })
], ProductPagePreview);
export default ProductPagePreview;
